<template>
    <v-row dense>
        <v-col
                cols="12"
                dense>
            <v-select
                    v-model="value"
                    dense
                    outlined
                    :items="options"
                    :chips="isMultiple"
                    :multiple="isMultiple"
                    clearable
                    @change="change" />
        </v-col>
    </v-row>
</template>
<style>
.field-option-checkbox .v-label {
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
}
</style>
<script>
    import Value from "@/models/value.model";
    import Field from "@/models/field.model";

    export default {
        name: "FieldSelectComponent",
        props: {
            field: {type: Object, default: () => new Field()},
        },
        data() {
            return {
                value: {},
            }
        },
        computed: {
            options() {
                return this.field.options.filter(o => o.is_visible).map(o => {
                    return {
                        text: o.value,
                        value: o.id
                    }
                })
            },
            isMultiple() {
                return this.field.options.some(o => !o.is_exclusive)
            }
        },
        watch: {
            value: {
                deep: true,
                handler() {
                    this.getValue().then((value) => {
                        this.$emit('updateValue', value);
                    })
                }
            }
        },
        mounted() {
            this.value = this.field.value.value;
        },
        methods: {
            /**
             *
             * @returns {Value}
             */
            async getValue() {
                const value = new Value({
                    value: this.value,
                    isEmpty: this.isEmpty()
                });

                if (!this.field.is_optional && value.isEmpty) {
                    this.error = 'Mandatory field';
                } else {
                    value.isValid = true;
                    this.error = null;
                }

                value.error = this.error;

                return value;
            },
            isEmpty() {
                return !(Array.isArray(this.value) ? this.value.length : this.value);
            },
            isValid() {
                return true;
            },
            change(val) {
                if (this.isMultiple) {
                    const exclusiveSelected = val.find(o => {
                        let option = this.field.options.find(fo => fo.id === o)
                        return option && option.is_exclusive
                    });
                    if (exclusiveSelected) {
                        this.value = [exclusiveSelected];
                    }
                }
            }
        }
    }
</script>